import { customSeriesDefaultOptions, CustomSeriesOptions } from 'lightweight-charts'

export interface VertLineOptions extends CustomSeriesOptions {
    color: string;
    opacity: number
    labelText: string;
    width: number;
    labelBackgroundColor: string;
    labelTextColor: string;
    showLabel: boolean;
    lineType: 'simple' | 'dotted' | 'dashed'
}

export const defaultOptions: VertLineOptions = {
    ...customSeriesDefaultOptions,
    color: 'green',
    labelText: '',
    opacity: 0.5,
    width: 2,
    labelBackgroundColor: 'green',
    labelTextColor: 'white',
    showLabel: false,
    lineType: 'simple'
}
